<template>

 <v-container fluid>
   <v-dialog
     v-model="dialog"
     persistent
     width="500"
   >
     <v-card>
       <v-card-title class="headline grey lighten-2">
         Selecionar Setor
       </v-card-title>
       <v-card-text>
         <v-select
           v-model="selectObjetEntity"
          :items="itemMe.entities"
           no-data-text="sem informações"
           item-text="name"
           item-value="id"
           hide-details
         >

         </v-select>
       </v-card-text>

       <v-divider></v-divider>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn
           color="primary"

           @click="selectEntity(selectObjetEntity)"
         >
          selectionar
         </v-btn>
         <v-btn
           color="primary"
           @click="dialog = false"
         >
           cancelar
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>
   <v-row dense justify="center">
     <v-avatar
       color="warning lighten-2"
       size="120"

     >
       <v-img
        v-if="avatar"
       :src="avatar"
       :alt="UserName"
       >

       </v-img>
       <v-img v-else  src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
     </v-avatar>
   </v-row>
   <v-row dense justify="center">
     <span><strong>{{UserName}}</strong></span>
   </v-row>
   <v-row dense justify="center">
     <span>Cargo:<strong>   &nbsp;{{access}}</strong></span>
   </v-row>
   <v-row dense justify="end" justify-sm="center" class="pl-16 pl-lg-0 pl-md-0 pl-sm-0 pl-xl-0" >
     <span>Setor:<strong>   &nbsp;{{setor}}</strong> <v-btn x-small  @click="dialogSelect" color="primary">Trocar De Setor</v-btn></span>
   </v-row>
   <v-row class="mt-3" justify="center" align="center">
       <strong>Assinatura Digital</strong>
     <v-tooltip bottom>
       <template v-slot:activator="{ on,attrs  }">
         <v-btn icon @click="enableAss">
         <v-icon  v-bind="attrs"  v-on="on"  color="primary">mdi-draw</v-icon>
         </v-btn>
       </template>
       <span>Editar Assinatura Digital</span>
     </v-tooltip>
     <v-tooltip v-if="btn" bottom>
       <template v-slot:activator="{ on,attrs  }">
         <v-btn   small  v-bind="attrs"  v-on="on" @click="salveSignature" class="ml-3 primary" v-if="btn" >
          Salvar
         </v-btn>
       </template>
       <span>Salvar Assinatura Digital</span>
     </v-tooltip>

     </v-row>
   <v-row  justify="center">
     <v-col  cols="12" lg="6" xl="6" md="6" sm="6">
       <ckeditor   :read-only="enable" placeholder="Type here..." v-model="valor" tag-name="textarea"
                 :config="config"></ckeditor>

     </v-col>
     </v-row>
   <ValidationObserver ref="observer" v-slot="{ passes }">
   <v-row dense align="center"  justify="center" v-show="has_countersign">
     <v-col  cols="12" lg="6" xl="6" md="6" sm="6">
       <v-card class="elevation-2">
       <v-col  cols="12" >
        <span>Quantidade</span>

      <v-row dense  class="mt-3" >

        <v-col  cols="12" lg="10" xl="10" md="10" sm="12">
          <ValidationProvider  rules="positive" v-slot="{ errors }" name="quatity">
          <v-slider
                  dense
                  hide-details
                  :error-messages="errors"
                  v-model="quantity"
                  thumb-color="red"
                  :thumb-size="20"
                  thumb-label="always"
                  step="5"
          ></v-slider>
          </ValidationProvider>
        </v-col>
        <v-col   cols="12" lg="2" xl="2" md="2" sm="2">
          <v-btn color="primary" small @click="passes(generateKey)"  v-if="!status" dark>Gerar</v-btn>
          <v-btn color="primary" small  v-else @click="passes(generateKey)" dark>Resetar  </v-btn>
        </v-col>

      </v-row>

      <v-row dense >
        <v-col   cols="12" lg="6" xl="6" md="6" sm="6 ">
          <v-row dense >
            <v-col  cols="3"  sm="4">
              <h4>Atual:</h4>
            </v-col>
            <v-col cols="6" >
              <span id="code">{{countersign.secret}}</span>
            </v-col>
            <v-col cols="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon  v-bind="attrs"
                           v-on="on"
                           color="primary"
                           v-clipboard="countersign.secret"
                  >mdi-content-copy</v-icon>
                </template>
                <span>Copiar Senha</span>
              </v-tooltip>

            </v-col>
          </v-row>
        </v-col>
        <v-col   cols="12" lg="2" xl="2" md="3" sm="4 ">
          <v-row dense justify="start" justify-lg="center" justify-md="center" justify-sm="center" >
            Quantidade:
          </v-row>
          <v-row dense justify="start">
            {{countersign.quantity}}
          </v-row>
        </v-col>

        <v-col   cols="2">
          <v-row dense justify="center">
            Saldo:
          </v-row>
          <v-row dense justify="center">
            {{countersign.balance}}
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
     </v-col>
   </v-row>
   </ValidationObserver>
 </v-container>
</template>

<script>

  import HashCodeMixin from '@/mixins/hash-code'
  import {CreateMutation} from '@/graphql/mutations/Countersign.gql'

  import checkPermissionsMixin from '@/mixins/check-permissions'
  import {ValidationObserver, ValidationProvider} from "vee-validate";

  export default {
  name: 'ViewCountersign',
  mixins:[HashCodeMixin,checkPermissionsMixin],
  components:{
      ValidationObserver,
      ValidationProvider
  },
  data () {
    return {
      secret:'Senha',
      quantity:5,
      dialog: false,
      status : false,
      enable:true,
      btn:false,
      ativo:true,
      prosVal:[],
      itemMe:[],
      content:'',
      iduser:'',
      selectObjetEntity:{},
      permissions: {},
      countersign:{
        secret:0,
        quantity:0,
        balance:0
      },
    }
  },
  watch:{
   dialog(val){
    if(val){
     this.$apollo.query({
      query:require('@/graphql/queries/Entity.gql').Me,
     }).then((data)=>{
      this.itemMe = data.data.me
     }).catch((err)=>{
      console.error(err)
     })
    }
   }
  },
  computed:{
    has_countersign(){
      return this.$store.state.pivot.has_countersign
    },
    config(){
      return this.$store.state.editorConfig
    },
    valor:{
        get(){
          return this.$store.state.pivot.signature
      },
      set(value){
        this.content = value
      }
    },
    setor(){
      if(this.$store.state.enti){
        return this.$store.state.enti.name
      }else{
        return this.$store.state.defaultClient.name
      }

    },
   editorData(){
    return this.$store.state.pivot.signature
   },
   avatar(){
    return this.$store.state.userAvatar
   },
   UserName(){
    return this.$store.state.userName
   },
   access () {
     return this.$store.state.possition.name ?  this.$store.state.possition.name : this.$store.state.possition
   },
   signature(){
    return this.$store.state.pivot.signature
   },
  dataSubmit() {

      const data = {
          secret: this.countersign.secret,
          quantity: this.quantity,
          balance: this.countersign.balance,
      };
      console.log(data)
      return data;
  },
  },
  methods:{
    dialogSelect(){
      if(this.access == 'Administrador' || this.access == 'Gestores' ){
        this.dialog = false
        this.$toasted.global.defaultError("usuario atual é administrador ou Gestor")
      }else{
        this.dialog = true
      }

    },
   openConfirm(value) {
    this.content = value

   },
   salveSignature(){
   this.enable = true
   this.btn = false
   this.prosVal = true
   this.ativo =true
     this.$apollo.mutate({
         mutation: require('@/graphql/mutations/Entity.gql').UpdatePivotEntityUserMutationSignature,
         variables:{
             id:this.$store.state.pivot.id,
             signature: this.content
         }
     }).then((data)=>{
          this.$store.dispatch('updateUserPivot', data.data.updateEntityUser)

     }).catch(({graphQLErrors})=>{
         console.error(graphQLErrors)
     })
 },
   enableAss(){

    this.enable = false
    this.btn = true
   },
   selectEntity(val){
    this.$apollo.mutate({
     mutation: require('@/graphql/mutations/Entity.gql').UpdateConnectMutation,
     variables:{
      id:this.itemMe.id,
      entity:val,
     },
     errorPolicy:(er)=>{
      console.error(er)
     }
    }).then((data)=>{
     
     const id = data.data.connectUserEntity.entity.id
     this.itemMe = data.data.connectUserEntity
      this.$store.dispatch('updateUserPosition', data.data.connectUserEntity.entities[0].position_pivot)
     const Entity = this.$store.state.entity.find((e)=>{
      if(id === e.id){
       return e
      }
     })
     this.$store.dispatch('updateUserPosition', Entity.position_pivot.position[0])

    }).catch((err)=>{
     console.error(err)
    })
    this.dialog = false
   },
    generateKey () {
      const key =  this.hashCode(6)
      this.countersign.balance = 0
      this.status = true
      this.countersign.secret = key

      this.$apollo.mutate({
           mutation:CreateMutation,
           variables: {
               ...this.dataSubmit,
           },
       }).then((data)=>{
          this.countersign.quantity = data.data.createCountersign.quantity
          this.countersign.balance = data.data.createCountersign.balance
          this.$toasted.global.defaultSuccess();
       }).catch(({graphQLErrors})=>{
           console.error(graphQLErrors)
       })

    }
  },

  updated() {

  }
 }
</script>

<style scoped>

</style>
